import GitHubIcon from "@mui/icons-material/GitHub";
import LanguageIcon from "@mui/icons-material/Language";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Box, IconButton, Typography } from "@mui/material";
import React from "react";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: 0,
        py: 3,
        px: 2,
        textAlign: "center",
        bgcolor: "background.paper",
        borderTop: "1px solid",
        borderColor: "divider",
      }}
    >
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        ⚠️ <strong>Disclaimer:</strong> This Mortgage Simulator is for
        educational and informational purposes only. It is a work in progress
        and may contain bugs or inaccuracies. Please do not rely on it for real
        financial decisions.
      </Typography>

      <Box sx={{ mb: 1 }}>
        <IconButton
          component="a"
          href="https://macbride.me"
          target="_blank"
          rel="noopener noreferrer"
          color="inherit"
        >
          <LanguageIcon />
        </IconButton>
        <IconButton
          component="a"
          href="https://www.linkedin.com/in/conormacbride"
          target="_blank"
          rel="noopener noreferrer"
          color="inherit"
        >
          <LinkedInIcon />
        </IconButton>
        <IconButton
          component="a"
          href="https://github.com/ConorMacBride"
          target="_blank"
          rel="noopener noreferrer"
          color="inherit"
        >
          <GitHubIcon />
        </IconButton>
      </Box>

      <Typography
        variant="caption"
        color="text.disabled"
        display="block"
        sx={{ mt: 1 }}
      >
        © {new Date().getFullYear()} Conor MacBride. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
